import { defineComponent as _defineComponent } from 'vue'
import { toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "label-check py-1" }
const _hoisted_2 = ["label", "disabled", "checked", "name"]
const _hoisted_3 = { key: 0 }

import { computed, withDefaults, useAttrs, watch } from 'vue';
import omit from '@/utils/omit';

// const { calcFieldSize } = useField()


const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  modelValue?: any;
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomRadio',
  props: {
    modelValue: { default: '' },
    label: {},
    disabled: { type: Boolean },
    checked: { type: Boolean },
    name: {}
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
// const emit = defineEmits(['click', 'keydown', 'update:modelValue', 'focus', 'update:hint'])

const attrs = useAttrs();

const listeners = computed(() => ({
  input: emitValue,
  keydown: processValue,
  blur: (e: Event) => {
    if (typeof attrs.onBlur === 'function') attrs.onBlur(e);
  },
  focus: (e: PointerEvent) => emit('focus', e),
}));

const attributes = computed(() => omit(attrs, 'class'));

const processValue = (event: KeyboardEvent) => {
  if (!event.key) return;

  emit('keydown', event);
};

const emitValue = (event: InputEvent) => {
  const value = (event.target as HTMLInputElement).checked;
  emit('update:modelValue', value);
};
// const value = computed({
//   get: () => props.modelValue,
//   set: (value: any) => emit('update:modelValue', value),
// })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", _mergeProps({ type: "radio" }, attributes.value, {
      label: props.label,
      disabled: _ctx.disabled,
      checked: _ctx.checked
    }, _toHandlers(listeners.value, true), {
      name: props.name
    }), null, 16, _hoisted_2),
    (props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})